import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { separarValorUnidad } from '../../helpers/splitValueUnit'
import GenericSelect from '../reutilizables/genericSelect/GenericSelect'
import styles from './MetadatosCampos.module.css'

export const MetadatosCampos = ({
  metadato,
  actualizarMetadato,
  editable,
  esPublicar,
  guardarMetaDatoAdministrar,
  dosColumnas = false
}) => {
  const valorActual = metadato.valorActual
  const [inputValue, setInputValue] = useState(null)
  const [unidadValue, setUnidadValue] = useState('')
  const tieneValor = Boolean(String(metadato.valorActual ?? '').trim())

  const tieneUnidad = metadato.idMetaDatoTipo === 'number_unit'
  const esCampoNumber =
    metadato.idMetaDatoTipo === 'number' || metadato.idMetaDatoTipo === 'number_unit'

  useEffect(() => {
    const { valorBase, unidad } = separarValorUnidad(valorActual, metadato.idMetaDatoTipo)
    setInputValue(valorBase)
    setUnidadValue(unidad)
  }, [valorActual])

  if (!editable && !tieneValor) {
    return null
  }

  return (
    <div
      key={metadato.idMetaDato}
      className={`${styles.campo} ${dosColumnas ? styles.campoDosColumnas : ''}`}
    >
      {tieneValor && !editable && (
        <>
          <span className={styles.etiqueta}>{metadato.etiqueta}:</span>
          <div className={styles.inputWrapper}>
            <span className={styles.valorTexto}>{metadato.valor}</span>
          </div>
        </>
      )}
      {editable && (
        <>
          <span className={styles.etiqueta}>{metadato.etiqueta}:</span>
          <div className={styles.inputWrapper}>
            {metadato.idMetaDatoTipo === 'boolean' ? (
              <GenericSelect
                options={[
                  { value: 'Si', label: 'Si', key: 'si' },
                  { value: 'No', label: 'No', key: 'no' }
                ]}
                name="metadatos"
                value={inputValue}
                onChange={(valor) => {
                  setInputValue(valor)
                  actualizarMetadato(metadato.idMetaDato, valor)
                  if (!esPublicar) {
                    guardarMetaDatoAdministrar(metadato.idMetaDato, valor)
                  }
                }}
              />
            ) : (
              <>
                <input
                  type={esCampoNumber ? 'number' : 'text'}
                  name="metadatos"
                  className={styles.input}
                  value={
                    esCampoNumber
                      ? inputValue === '' || !isNaN(inputValue)
                        ? inputValue
                        : ''
                      : inputValue
                  }
                  onChange={(e) => {
                    setInputValue(e.target.value)
                    actualizarMetadato(
                      metadato.idMetaDato,
                      e.target.value,
                      tieneUnidad ? unidadValue : ''
                    )
                  }}
                  onBlur={() => {
                    if (!esPublicar) {
                      guardarMetaDatoAdministrar(
                        metadato.idMetaDato,
                        tieneUnidad ? `${inputValue} ${unidadValue}`.trim() : inputValue
                      )
                    }
                  }}
                />
                {tieneUnidad && (
                  <input
                    type="text"
                    placeholder="Unidad"
                    name={`unidad_${metadato.idMetaDato}`}
                    className={styles.inputUnidad}
                    value={unidadValue}
                    onChange={(e) => {
                      actualizarMetadato(metadato.idMetaDato, inputValue, e.target.value)
                      setUnidadValue(e.target.value)
                    }}
                    onBlur={() => {
                      if (!esPublicar) {
                        guardarMetaDatoAdministrar(
                          metadato.idMetaDato,
                          `${inputValue} ${unidadValue}`.trim()
                        )
                      }
                    }}
                  />
                )}
              </>
            )}
          </div>
        </>
      )}
    </div>
  )
}

MetadatosCampos.propTypes = {
  metadato: PropTypes.shape({
    idMetaDato: PropTypes.number.isRequired,
    etiqueta: PropTypes.string.isRequired,
    valorActual: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    idMetaDatoTipo: PropTypes.string.isRequired,
    valor: PropTypes.string
  }).isRequired,
  actualizarMetadato: PropTypes.func.isRequired,
  editable: PropTypes.bool.isRequired,
  esPublicar: PropTypes.bool.isRequired,
  guardarMetaDatoAdministrar: PropTypes.func.isRequired,
  dosColumnas: PropTypes.bool
}
